import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";

import { DormitoryTab } from "components/pages/dormitories-page";
import { Container, Row } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import DormitoriesApi from "api/dormitories-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useQueryParams from "hooks/useQueryParams";
import { getDormitoryCompletnessProgress } from "hooks/useStepsOptions";
import { useStorageListener } from "hooks/useStorage";

const DormitoriesListPage = () => {
    const { t } = useTranslation();

    const { params } = useQueryParams();
    const { universityId } = params;
    const navigate = useNavigate();
    useBodyBackground("white");

    const [dormitoriesProgress, setDormitoriesProgress] = useState({});

    const university = useStorageListener(`universities`, {});
    const dormitories = useStorageListener(`dormitories`, []);

    const selectedUniversity = _.get(university, universityId);

    const rows = _.values(dormitories)?.filter?.((i) => (!!universityId ? i?.universityId === universityId : true));
    console.log('render: rows = ', rows);

    // @ts-ignore
    useEffect(async () => {
        setDormitoriesProgress(_.zipObject(_.map(rows, `id`), await Promise.all(_.map(rows, `details`).map(getDormitoryCompletnessProgress))));
    }, [JSON.stringify(rows)]);

    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <Row extra="gap: 15px;">
                {universityId && (
                    <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>
                        {t("036p26d5q6hk")}
                    </DormitoryTab.Link>
                )}
                <h2>{t("bm38g0o5fze")}</h2>
            </Row>
            {universityId && (
                <Row extra="gap: 10px;">
                    <strong>{t("8lad6jnl7up")}</strong>
                    <p>{_.get(selectedUniversity, `details.name`)}</p>
                </Row>
            )}
            <Table
                name="admin-uni-dashboard"
                withPagination={false}
                useBackendProcessing={false}
                paginationPerPage={2000}
                rows={rows.map((i) => ({
                    ...i,
                    progress: dormitoriesProgress?.[i.id] ?? {},
                    progressLength: _.values(dormitoriesProgress?.[i.id] ?? {})?.filter?.((i) => i)?.length ?? 0,
                    number:
                        _.values(rows)
                            ?.map?.((i) => i?.createdTimestamp)
                            ?.indexOf?.(i?.createdTimestamp) + 1,
                    university: _.get(university, i.universityId),
                }))}
                sortable={true}
                columns={[
                    { name: `number`, label: `№`, extra: `width: 50px; flex: unset;`, showIndexOnClick: true },
                    // { name: `id`, label: `ID` },
                    {
                        name: `university.details.name`,
                        label: `Университет`,
                        extra: `flex: 2;`,
                        onCellClick: ({ row }) => navigate(`/university/${row.universityId}`),
                    },
                    { name: `details.main-info.name`, label: `Название`, extra: `flex: 2;` },
                    { name: `university.details.region`, label: `Субъект`, extra: `flex: 1.5;` },
                    { name: `details.main-info.city`, label: `Город` },
                    {
                        name: `onModeration`,
                        label: `Ожидает модерации`,
                        transform: ({ row }) => (row?.onModeration ? t("igs9x5cjcfr") : t("iv9r5j6zkco"))
                    },
                    {
                        name: `hideFromAll`,
                        label: `Скрыт от всех`,
                        transform: ({ row }) => (row?.hideFromAll ? 'y-y' : '-'),
                        cell: {
                            type: "icon",
                            className: "w-6 h-6 cursor-pointer",
                            srcFunction:  (({ row }) => (row?.hideFromAll ? 'eye-x' : ''))
                        }
                    },

                    {
                        name: `progressLength`,
                        label: `Прогресс`,
                        extra: `width: 100px; flex: unset; justify-content: center;`,
                    },

                    {
                        name: `progress`,
                        label: ``,
                        extra: `width: 80px; flex: unset;`,
                        cell: { type: `dormitoryComplitnessStatus` },
                        sortable: false,
                    },
                    {
                        name: `menu`,
                        label: ``,
                        sortable: false,
                        extra: `flex: unset; width: 24px;`,
                        cell: {
                            type: `menu`,
                            options: [
                                { label: `Просмотр`, onClick: ({ row, navigate }) => navigate(`/dormitory/${row.id}`) },
                                {
                                    label: `Модерация пройдена`,
                                    onClick: ({ row, navigate }) => DormitoriesApi.updateDormitory({ id: row.id, onModeration: false }),
                                },
                                {
                                    label: `Вернуть на модерацию`,
                                    onClick: ({ row, navigate }) => DormitoriesApi.updateDormitory({ id: row.id, onModeration: true }),
                                },
                            ],
                        },
                    },
                ]}
            />
        </Container>
    );
};

export default DormitoriesListPage;
